import { useState } from "react";
import HeroSection from "./components/HeroSection/HeroSection ";
import './Home.css';
import Navbar from "./components/Navbar/Navbar";
import WhoWeAreSection from "./components/WhoWeAreSection/WhoWeAreSection";
import ChallengesSection from "./components/ChallengesSection/ChallengesSection";
import WhatWeOfferSection from "./components/WhatWeOfferSection/WhatWeOfferSection";
import WhyChooseSalesTology from "./components/WhyChooseSalesTology/WhyChooseSalesTology";
import ContactForm from "./components/ContactForm/ContactForm";
import SalesTologyFooter from "./components/SalesTologyFooter/SalesTologyFooter";
import CapabilityImprovementProcess from "./components/CapabilityImprovementProcess/CapabilityImprovementProcess";


const Home = () => {

  return (
    <div className="app">
      <Navbar />
      <HeroSection />
      <WhoWeAreSection/>
      <ChallengesSection/>
      <WhatWeOfferSection/>
      <WhyChooseSalesTology/>
      <CapabilityImprovementProcess/>
      <ContactForm/>
      <SalesTologyFooter/>
    </div>
  );
};

export default Home;